import 'bootstrap/dist/css/bootstrap.min.css';
import { font } from './Constants';
import { injectGlobal } from 'styled-components';

injectGlobal`
  html {
    -webkit-font-smoothing: antialiased;
  }
  body {
    font-family: ${font.openSans};
    padding: 0;
    margin: 0;
    background-color: #F0EEE8;
  }
  input.has-error, select.has-error, textarea.has-error {
    border-color: red;
    margin-bottom: 30px;
  }
  input[type="date"]::-webkit-calendar-picker-indicator,
  input[type="date"]::-webkit-inner-spin-button{
      display: none;
  }
  .swal-text {
    text-align: center;
  }
  
  .react-show-depa-map {
    height: 85%;
    top: calc(50% + 10px);
    @media(min-width: 992px) {
      height: 82%;
      top: 18%;
    }
  }
  
  .react-show-map {
    height: 85%;
    top: calc(50% + 10px);
    @media(min-width: 992px) {
      height: 100%;
      width:100%;
      top: 0%;
    }
  }
  
  .react-map {
    height: 100%;
    top:0%;
    @media(min-width: 992px) {
      height: 100%;
      width:100%;
      top: 0%;
    }
  }
  
  div[id^="mati-container-"] .mati-button.mati-background-light > p {
    color: white !important;
  }
`;
